import { createReducer, on } from '@ngrx/store';
import { setFeedbackListPageNumber, setFeedbackListItemsPerPage } from '../actions/feedback.action';

export interface FeedbackState {
    pageNumberFeedbackList: number;
    itemsPerPageFeedbackList: number;
}

export const initialState: FeedbackState = {
    pageNumberFeedbackList: 1,
    itemsPerPageFeedbackList: 10,

};

export const feedbackReducer = createReducer(
    initialState,
    on(setFeedbackListPageNumber, (state, { pageNumberFeedbackList }) => ({ ...state, pageNumberFeedbackList })),
    on(setFeedbackListItemsPerPage, (state, { itemsPerPageFeedbackList }) => ({ ...state, itemsPerPageFeedbackList })),
);